import { PaintedScene } from '../PaintedScene';

export const DONCHITOS_HAMLET_PHASER_KEY = 'DonchitosHamletScene' as const;
export const DONCHITOS_HAMLET_MANIFEST_KEY = 's-101-donchitos-hamlet' as const;

export class DonchitosHamletScene extends PaintedScene {
  constructor() {
    super(DONCHITOS_HAMLET_PHASER_KEY, DONCHITOS_HAMLET_MANIFEST_KEY);
  }
}
